// extracted by mini-css-extract-plugin
export default {"root":"kGOiO9HSw7_MekJcwsRM","tableContent":"cBnLmoxUC2fPY0aH8tB8","table":"moNWfSbglRDVjmLtfjvw","placeHolderShimmer":"TN2L7OfZyyqWUG6igSPI"};